<template>
  <div class="nose">
    <div class="nose__inner">
      <div class="header">
        <h3>{{ num }}. {{ title }}</h3>
        <v-btn @click="add" class="ma-1 amber" fab small light :disabled="maxItems">
          <v-icon>mdi-plus</v-icon></v-btn
        >
      </div>
      <div class="description" v-html="description"></div>
      <div class="content">
        <div class="content__item" :style="{ backgroundColor: `${bgColor}` }">
          <draggable
            class="inner mt-5"
            :list="items"
            group="order"
            @start="startDrag()"
            @end="endDrag()"
            :ref="name"
            :id="name"
          >
            <div
              v-for="(item, index) in items"
              :key="`unit-${index}`"
              class="item"
              :data-id="`${Math.round(new Date().getTime() / 1000)}`"
              :class="{ inactive: checkEditIndex(index) }"
            >
              <div class="item__text">
                <v-textarea
                  light
                  :color="color"
                  v-model="item.title"
                  :rows="1"
                  :autoGrow="true"
                  v-if="editMode"
                  :hide-details="true"
                  class="item__edit"
                />
                <p v-else>{{ item.title }}</p>
              </div>
              <div class="icons">
                <div @click="edit(index)" v-if="editMode && editIndex == index">
                  <v-icon class="body-1 ma-1 green--text"
                    >mdi-check-circle</v-icon
                  ><span class="body-2">OK</span>
                </div>
                <div @click="edit(index)" v-else>
                  <v-icon class="body-1 grey--text">mdi-pencil</v-icon
                  ><span class="body-2">Edit</span>
                </div>
                <div @click="remove(index)">
                  <v-icon class="ml-2 body-1 grey--text"
                    >mdi-delete-forever</v-icon
                  ><span class="body-2">Delete</span>
                </div>
              </div>
            </div>
          </draggable>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="800">
      <v-card v-if="deleteMode" light>
        <v-card-title>
          Are you sure you want to delete this item?
        </v-card-title>
        <v-card-text class="">
          <v-btn light color="amber mr-5" class="" @click="removeItem"
            >Delete</v-btn
          >
          <v-btn light color="white" class="" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
      <v-card light v-else>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text class="">
          <p class="body-1" v-html="description"></p>
          <p class="small">Type in the box below</p>
          <v-textarea
            color="amber"
            v-model="item.title"
            :rows="4"
            :autoGrow="true"
            :hide-details="false"
          />
          <v-btn
            light
            color="amber mr-5"
            class="mt-2 add-button"
            @click="addItem"
            >Add</v-btn
          >
          <v-btn light color="white" class="mt-2" @click="cancel">Cancel</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import draggable from "vuedraggable";
export default {
  name: "UnitItemsCenter",
  data() {
    return {
      items: this.value,
      item: {},
      currIndex: null,
      refs: null,
      fields: [],
      editMode: false,
      editIndex: null,
      deleteMode: false,
      deleteId: null,
      dialog: false,
    };
  },
  props: {
    value: Array,
    name: String,
    title: String,
    num: String,
    label: String,
    description: String,
    color: String,
    limit: {
      type: Number,
      default: 3,
    },
    svg: {
      type: String,
      default: "",
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    bgMode: {
      type: Boolean,
      default: false,
    },
    formAbove: {
      type: Boolean,
      default: true,
    },
    bgColor: {
      type: String,
    },
  },
  components: {
    draggable,
  },
  watch: {
    value: {
      handler: function(val) {
        this.items = val;
      },
      deep: true,
    },
  },
  computed: {
    direction() {
      return this.reverse ? "row-reverse" : "row";
    },
    bgSrc() {
      if (this.svg) {
        return require(`@/assets/${this.svg}`);
      } else {
        return "";
      }
    },
    maxItems() {
      if (this.limit) {
        return (this.items && this.items.length) >= this.limit ? true : false;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.collection) {
      this.getRefs();
    }
  },
  methods: {
    add() {
      this.dialog = true;
    },
    addItem() {
      let item = {
        index: this.items.length,
        title: this.item.title,
        id: this.items.length,
        type: "content",
      };
      this.items.push(item);
      this.item = {};
      this.editMode = false;
      this.currId = null;
      this.currIndex = null;
      this.dialog = false;
    },
    remove(index) {
      this.deleteMode = true;
      this.deleteId = index;
      this.dialog = true;
    },
    removeItem() {
      this.items.splice(this.deleteId, 1);
      this.cancel();
    },
    cancel() {
      this.dialog = false;
      this.deleteId = null;
      this.deleteMode = false;
    },
    edit(index) {
      this.editMode = !this.editMode;
      this.editIndex = index;
    },
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById(this.name);
      div.children.forEach((doc) => {
        let item = this.items.find((x) => x.id == doc.dataset.id);
        console.log(item);
        let indexOfItem = this.items.indexOf(item);
        item.index = count;
        vm.$set(vm.items, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    checkEditIndex(index) {
      if (this.editMode) {
        return index == this.editIndex ? false : true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nose {
  min-height: 80vh;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  &__inner {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
  }
  .header {
    width: 100%;
    padding: 1rem 0 0 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
      border-bottom: 2px solid white;
    }
  }
  .description {
    padding: 0.25rem 1rem 0 1rem;
  }
  .content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .inner {
      width: 90%;
    }
    &__item {
      min-height: 500px;
      border-radius: 50%;
      align-items: center;
      justify-content: center;
      display: flex;

      width: 100%;
      .item {
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin: 0.75rem 0;
        border-radius: 0px;
        color: black;
        width: 100%;
        flex-direction: column;
        background: white;
        p {
          text-align: left;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
          font-size: 1rem;
          line-height: 1.5rem;
          margin: 0;
          font-weight: 400;
        }
        .icons {
          width: 100%;
          padding: 0.2rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 0.5rem 0 0 0;
          background: rgba(0, 0, 0, 0.2);
          pointer-events: auto;
          span {
            cursor: pointer;
          }
        }
        &__edit {
          text-align: left;
          font-size: 1rem;
          line-height: 0.9rem;
          margin: 0;
          padding: 0.5rem 0.5rem 0.5rem 0.5rem;
          font-weight: 400;
          width: 100%;
          color: black;
        }
        &__text {
          width: 100%;
        }
      }
    }
  }
}
.inactive {
  // opacity: 0;
  visibility: hidden;
}
.flex-1 {
  flex: 1;
}
</style>
